import App from "./app";
import bkgImage from "./partials/bkg-image";
import carousel from "./partials/carousel";
import homepage from "./partials/homepage";
import footer from "./partials/footer";
import sponsors from "./partials/sponsors";
import contentCheck from "./partials/content-check";
import b2bLink from "./partials/b2b-link";
import dropdowns from "./partials/dropdowns";
import accordion from "./partials/accordion";
import cardLightbox from "./partials/card-lightbox";
import mw2026Spirals from "./partials/mw-2026-spirals";
import mw2026SponsorPackages from "./partials/mw-2026-sponsor-packages";

export default function() {
  console.log();
  bkgImage();
  homepage();
  footer();
  carousel();
  sponsors();
  contentCheck();
  b2bLink();
  dropdowns();
  accordion();
  cardLightbox();
  mw2026Spirals();
  mw2026SponsorPackages();
}



// WEBPACK FOOTER //
// ./src/js/index.js